/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pnk_Item_Err_Pick_PurchaseInputs */

const vi_pl_pnk_item_err_pick_purchase = /** @type {(inputs: Pl_Pnk_Item_Err_Pick_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn đơn mua cho lô mới`)
};

/**

* @param {Pl_Pnk_Item_Err_Pick_PurchaseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pnk_item_err_pick_purchase = /** @type {((inputs?: Pl_Pnk_Item_Err_Pick_PurchaseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pnk_Item_Err_Pick_PurchaseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pnk_item_err_pick_purchase(inputs)
});